import React from "react";
import { Link } from "react-router-dom";

const NavBrand = ({ transparent }) => (
  <Link to="/" className="flex flex-col leading-none group">
    <span
      className={`brand-title text-lg md:text-xl transition-colors duration-500 ${
        transparent ? "text-white" : "text-[#3a3736]"
      }`}
      style={{ letterSpacing: "0.14em" }}
    >
      ROGER MINNER
    </span>
    <span
      className={`font-sans-el text-[0.6rem] tracking-[0.42em] uppercase mt-1 transition-colors duration-500 ${
        transparent ? "text-white/80" : "text-[#9a878b]"
      }`}
    >
      Homes
    </span>
  </Link>
);

export default NavBrand;
